module.exports = __webpack_public_path__ + "img/demo_konto_tiny.fa6d6f7d.png";